<div class="page">
    <div class="page-title" *ngIf="isVisible">
        <h1>{{title}}</h1>
    </div>
    <div class="page-content">
        <ng-content></ng-content>
    </div>
</div>
